export const FETCH_CAMPAIGNS_REQUEST = 'FETCH_CAMPAIGNS_REQUEST';
export const FETCH_CAMPAIGNS_SUCCESS = 'FETCH_CAMPAIGNS_SUCCESS';
export const FETCH_CAMPAIGNS_FAILURE = 'FETCH_CAMPAIGNS_FAILURE';

export const FETCH_CAMPAIGNS_NEXT_REQUEST = 'FETCH_CAMPAIGNS_NEXT_REQUEST';
export const FETCH_CAMPAIGNS_NEXT_SUCCESS = 'FETCH_CAMPAIGNS_NEXT_SUCCESS';
export const FETCH_CAMPAIGNS_NEXT_FAILURE = 'FETCH_CAMPAIGNS_NEXT_FAILURE';

export const FETCH_CAMPAIGN_REQUEST = 'FETCH_CAMPAIGN_REQUEST';
export const FETCH_CAMPAIGN_SUCCESS = 'FETCH_CAMPAIGN_SUCCESS';
export const FETCH_CAMPAIGN_FAILURE = 'FETCH_CAMPAIGN_FAILURE';

export const FETCH_CAMPAIGN_WIZARD_DATA_REQUEST = 'FETCH_CAMPAIGN_WIZARD_DATA_REQUEST';
export const FETCH_CAMPAIGN_WIZARD_DATA_SUCCESS = 'FETCH_CAMPAIGN_WIZARD_DATA_SUCCESS';
export const FETCH_CAMPAIGN_WIZARD_DATA_FAILURE = 'FETCH_CAMPAIGN_WIZARD_DATA_FAILURE';

export const ADD_CAMPAIGN_REQUEST = 'ADD_CAMPAIGN_REQUEST';
export const ADD_CAMPAIGN_SUCCESS = 'ADD_CAMPAIGN_SUCCESS';
export const ADD_CAMPAIGN_FAILURE = 'ADD_CAMPAIGN_FAILURE';

export const UPDATE_CAMPAIGN_REQUEST = 'UPDATE_CAMPAIGN_REQUEST';
export const UPDATE_CAMPAIGN_SUCCESS = 'UPDATE_CAMPAIGN_SUCCESS';
export const UPDATE_CAMPAIGN_FAILURE = 'UPDATE_CAMPAIGN_FAILURE';

export const DELETE_CAMPAIGN_REQUEST = 'DELETE_CAMPAIGN_REQUEST';
export const DELETE_CAMPAIGN_SUCCESS = 'DELETE_CAMPAIGN_SUCCESS';
export const DELETE_CAMPAIGN_FAILURE = 'DELETE_CAMPAIGN_FAILURE';

export const RESET_CAMPAIGN_DATA = 'RESET_CAMPAIGN_DATA';

export const FETCH_CAMPAIGNS_FEED_REQUEST = 'FETCH_CAMPAIGNS_FEED_REQUEST';
export const FETCH_CAMPAIGNS_FEED_SUCCESS = 'FETCH_CAMPAIGNS_FEED_SUCCESS';
export const FETCH_CAMPAIGNS_FEED_FAILURE = 'FETCH_CAMPAIGNS_FEED_FAILURE';

export const OPEN_CAMPAIGNS_SIDEPANEL = 'OPEN_CAMPAIGNS_SIDEPANEL';
export const CLOSE_CAMPAIGNS_SIDEPANEL = 'CLOSE_CAMPAIGNS_SIDEPANEL';
